import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';

import AuthLayout from 'layouts/Auth';
import AdminLayout from 'layouts/Admin';
import './index.css';
import {CookiesProvider} from 'react-cookie';
import {ApolloProvider} from '@apollo/client/react';
import {ThemeProvider} from './contexts/ThemeContext';
// TEMP: Commented out for initial build
// import { ErrorBoundary } from '@collabra/cway-frontend-common/components';

// GraphQL client
import ApolloClient from './graphql/Apollo';

// Initialize authentication from localStorage
import Api from './Api';
import {setupAxiosInterceptors, startTokenRefreshInterval} from './utils/tokenRefresh';

Api.initializeAuth();

// Set up automatic token refresh
setupAxiosInterceptors();
startTokenRefreshInterval();

// TEMP: Simple ErrorBoundary replacement
const ErrorBoundary = ({children}: {children: React.ReactNode}) => <>{children}</>;

const root = createRoot(document.getElementById('root')!);
root.render(
  <ThemeProvider>
    <ApolloProvider client={ApolloClient}>
      <CookiesProvider>
        <ErrorBoundary>
          <BrowserRouter future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
            <Routes>
              <Route path="/admin/auth/*" element={<AuthLayout />} />
              <Route path="/admin/*" element={<AdminLayout />} />
              <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
            </Routes>
          </BrowserRouter>
        </ErrorBoundary>
      </CookiesProvider>
    </ApolloProvider>
  </ThemeProvider>,
);
